import React from "react";
import CommonRow from "../common-row";

const TwelveStoryOneAdsOneWidget = props => {
  return <CommonRow {...props} />;
};

export default TwelveStoryOneAdsOneWidget;
